import type { DSStatusEnum } from '@splunk/dashboard-types';

export const DS_STATUS: DSStatusEnum = {
    QUEUED: 'queued',
    PARSING: 'parsing',
    RUNNING: 'running',
    PAUSE: 'pause',
    FINALIZING: 'finalizing',
    FAILED: 'failed',
    STOPPED: 'stopped',
    DONE: 'done',
    CANCELED: 'canceled',
    REFRESHING: 'refreshing',
} as const;
